<div class="bk-popper">
	<div class="bk-popper__header">
		{{ f && f.FertilizerName.value }} 
	</div>
	<table class="bk-popper__table">
		<tr>
			<td class="bk-popper__column-1a">
				{{'Formulation' | translate }}:
			</td>
			<td class="bk-popper__column-2a">
				{{ f && f.IsFormulationTypeDry.value ? 'Dry' : 'Wet'}}
			</td>
		</tr>
		<tr>
			<td class="bk-popper__column-1a">
				{{'Nitrogen' | translate }}:
			</td>
			<td class="bk-popper__column-2a">
				{{ f && f.NPercentage.value}}%
			</td>
		</tr>
		<tr>
			<td class="bk-popper__column-1a">
				{{'Other Nutrients' | translate }}:
			</td>
			<td class="bk-popper__column-2a">
				{{ f && f.FertilizerOtherNutrients.value}}
			</td>
		</tr>
	</table>
</div>